<template>
  <el-button class="mt-10" @click="addAction()">添加路径</el-button>
  <div class="mt-10 bs-drill-item p-6"
       v-for="(item, index) in temData.drillActions" :key="index">
    <div :data-index="index" data-dtype="drillSet"
         v-swapListByDrag="temData.drillActions" data-target=".bs-drill-target">
      <div class="flex between bs-drill-target">
        <div class="font-weight bs-drill-item-title">
          <div v-if="!item.showEditName" @click="nameClick(item,index)">
            {{ item.name }}
          </div>
          <el-input ref="nameInputRefs" :autofocus="true" v-else v-model="item.name"
                    @blur="item.showEditName=false"></el-input>
        </div>
        <div>
          <el-icon>
            <Menu/>
          </el-icon>
          <el-icon color="#F56C6C" class="cursor" @click="delAction(index)">
            <Close/>
          </el-icon>
        </div>
      </div>
      <div class="bs-drill-content" draggable="false">
        <form-item labelAlign="left" :label-width="80" label="下钻类型" label-width="90">
          <el-radio-group v-model="item.drillType" size="small">
            <el-radio :label="DRILL_TYPE.IN">自定义下钻</el-radio>
            <el-radio :label="DRILL_TYPE.DYNAMIC">动态下钻</el-radio>
            <!-- <el-radio-button :label="DRILL_TYPE.OUT">其他页面</el-radio-button> -->
          </el-radio-group>
        </form-item>
        <template v-if="item.drillType !== DRILL_TYPE.OUT">
          <form-item labelAlign="left" :label-width="80" label="导航颜色" tip="下钻导航字体颜色" label-width="90">
            <el-color-picker :predefine="predefineColors" show-alpha
                             v-model="item.drillLabelColor"></el-color-picker>
          </form-item>
          <div v-for="(_item, _index) in item.drillList" :key="_index" class="vcenter flex between dirll-item">
            <span>{{ getDrillITem(_item).name }}</span>
            <el-icon class="pointer" @click="item.drillList.splice(_index, 1)">
              <Close/>
            </el-icon>
          </div>
          <template v-if="!item.readOnly">
            <el-tree-select
                v-if="item.drillType === DRILL_TYPE.IN"
                style="margin-top: 10px"
                @change="change(item)"
                v-model="item.selected"
                :data="list"
                :render-after-expand="false"
                placeholder="添加下一层钻取"
            />
            <el-tree-select
                v-else
                style="margin-top: 10px"
                @change="change(item,true)"
                v-model="item.selected"
                :data="list"
                :render-after-expand="false"
                placeholder="中介字段"
            />
          </template>
        </template>
      </div>
    </div>
  </div>
</template>
<script setup>
import {computed, reactive, ref, inject, nextTick} from "vue";
import {Close, Menu} from "@element-plus/icons-vue";
import {DRILL_TYPE, predefineColors} from "@/option/common/dict.js";
import {appMenuDao} from "@/option/common/dao.js";
import {cloneDeep} from "lodash-es";
import {ElMessageBox} from "element-plus";
import {vSwapListByDrag} from "@/option/common/directives";

const nameInputRefs = ref([])
let getApp = inject('getApp', null)
let app = getApp ? getApp() : inject("app")
let props = defineProps({
  temData: {},
  option: {},
  item: {},
});
let menuSelect = ref();
let menus = ref([]);

let selected = ref("");
//
let list = computed(() => {
  return props.option.rDimensions?.map((el) => {
    if (el.children) {
      return {
        ...el,
        label: el.name,
        value: el.code,
        children: el.children.map((i) => {
          return {
            ...i,
            label: i.name,
            value: i.code,
          };
        })
      };
    } else {
      return {
        ...el,
        label: el.name,
        value: el.code,
      };
    }
  });
});

function nameClick(item, index) {
  item.showEditName = true
  nextTick(() => {
    nameInputRefs.value[0].focus()
  })
}

// 这是老的单路径的下钻 需要兼容
if (!props.temData?.drillActions?.length && props.temData?.drillList?.length) {
  // 将老的配置兼容到新版配置
  props.temData.drillActions = [{
    name: `路径1`,
    drillLabelColor: props.temData.drillLabelColor,
    drillType: DRILL_TYPE.IN,
    drillList: props.temData?.drillList
  }]
}

function addAction() {
  if (!props.temData.drillActions) {
    props.temData.drillActions = []
  }
  props.temData.drillActions.push({
    name: `路径${props.temData.drillActions.length + 1}`,
    drillType: DRILL_TYPE.IN,
    drillList: []
  })
}

function delAction(index) {
  ElMessageBox.confirm('确认删除？').then(() => {
    props.temData.drillActions.splice(index, 1)
  })
}

function getDrillITem(dim, list = props.option.rDimensions) {
  // 找到下钻维度code
  let res;
  for (let i = 0; i < list.length; i++) {
    let el = list[i];
    if (el.code === dim) {
      return el;
    }
    if (el?.children?.length) {
      res = getDrillITem(dim, el.children);
    }
    if (res) return res;
  }
}

function handleNodeClick(data, node) {
  let p;
  if (node.parent) {
    p = `${node.parent.data.path}/`;
  }
  p += node.data.path;
  props.temData.aidaPagePath = p;
}

function change(item, flag) {
  if (item.selected) {
    if (flag) {
      item.drillList = [item.selected]
    } else {
      item.drillList.push(item.selected);
    }
  }
  item.selected = "";
}

getMenus();

function getMenus() {
  appMenuDao
      .getMenus({
        appId: app.id,
        version: app.currentVersion,
      })
      .then((el) => {
        handledSavedMenu(el);
        menus.value = el;
      });
}

function handledSavedMenu(list) {
  list.forEach((el) => {
    // 找到就删除
    el.label = el.showName;
    el.value = el.path;
    if (el?.children?.length) {
      handledSavedMenu(el.children);
    }
  });
}

function addItem() {
  if (!Array.isArray(props.temData.drillPageParam)) {
    props.temData.drillPageParam = [];
  }
  props.temData.drillPageParam.push({});
}
</script>

<style scoped lang="scss">
.dirll-item {
  margin-bottom: 2px;
  background-color: #d3dae7;
  border-bottom: 1px solid #fff;
  line-height: 28px;
  padding: 0 10px;
  width: calc(100% - 20px);
  color: var(--el-color-info);
}

.bs-drill-item {
  border: 1px solid rgb(210, 210, 210);
}

.bs-drill-item-title {
  font-size: 14px;

  &:hover {
    cursor: pointer;
  }
}
</style>
